angular.module('billing').controller('StatementModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', '$window', 'BillingRepository', 'loginUser',
        function ($scope, $modalInstance, $sce, $window, BillingRepository, loginUser) {
            'use strict';

            $scope.loadingStatement = true;
            $scope.model = {
                StatementData: '',
                PdfFileName: loginUser.fullName + '_Statement.pdf',
                Base64: '',
                ContentType: ''
            };

            function loadStatement() {
                BillingRepository.getStatementUrl(loginUser.id)
                    .then(function (data) {
                        if (data) {
                            var statementPdf = 'data:' + data.ContentType + ';base64,' + data.ByteArray;
                            $scope.model.StatementData = $sce.trustAsResourceUrl(statementPdf);
                            $scope.model.ByteArray = data.ByteArray;
                            $scope.model.ContentType = data.ContentType;
                        }
                    })
                    .finally(function () {
                        $scope.loadingStatement = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;

            loadStatement();
        }]);
